<template>
  <div id="offers">
    <header-o :model="headerData"></header-o>
    <div class="margin-10" style="margin-top: -180px">
      <div v-if="!isEmpty(giftCardData)">
        <div class="bg-light bottom-radius-5 padding-10 pos-rel box-shadow" style="min-height: 150px;">
          <div class="bottom-border">
            <div class="margin-bottom-10 font-bold text-regular">{{giftCardData.name}}</div>
            <img class="w30 margin-bottom-5" :src="giftCardData.image_url">
            <div class="margin-bottom-10 text-large" v-if="giftCardData.currency_label && giftCardData.value">Value: <span class="font-bold">₹{{giftCardData.value}}</span></div>
            <div class="align-hor center-ver space-between margin-bottom-10">
              <div>Validity: <span class="font-bold">{{giftCardData.expiry ? giftCardData.expiry : '1 year'}}</span></div>
              <div class="align-hor center-ver">
                <div class="margin-right-5">Use:</div>
                <div class="wrap align-hor center-ver center-hor padding-5 radius-3 text-small pointer" @click="toggleGiftModal(true, giftCardData)" :style="{border: '1px solid '+bgTheme}">
                  <img class="smaller-icon pull-left margin-right-5" :src="giftCardData.currency_icon_url"> {{giftCardData.currency_req}}
                </div>
              </div>
            </div>
          </div>
          <div class="padding-10">
            <div class="about text-left margin-bottom-20">
              <div class="font-bold margin-bottom-10">About</div>
              <div v-html="giftCardData.description"></div>
            </div>
            <div class="terms">
              <div class="align-hor center-ver space-between">
                <div class="font-bold">Terms & Conditions</div>
                <img class="w-15 margin-bottom-5 pointer" v-if="!isShowTNC" src="@/assets/arrow-down.svg" @click="toggleTNC(true)">
                <img class="w-15 margin-bottom-5 pointer" v-else src="@/assets/arrow-up.svg" @click="toggleTNC(false)">
              </div>
              <div v-if="isShowTNC">
                <ol class="text-left">
                  <li class="margin-bottom-10" v-if="giftCardData.tnc_link"><a :href="giftCardData.tnc_link">{{giftCardData.tnc_link}}</a></li>
                  <li class="margin-bottom-10 word-break" v-else v-html="giftCardData.tnc_content"></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <gift-popup :model="giftCardData" v-if="isGiftPopup"></gift-popup>
      </div>

      <div class="bg-light bottom-radius-5 padding-10 pos-rel box-shadow" v-if="isEmpty(giftCardData)">
        <div class="bg-light radius-5 padding-10 pos-rel">
          <div class="wrapper align-ver center-ver margin-bottom-15">
            <div class="comment animate bg-light-grey w40"></div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-15">
            <div class="comment animate bg-light-grey w30" v-for="$i in 6"></div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-15">
            <div class="comment animate bg-light-grey w30"></div>
          </div>
          <div class="align-hor center-ver space-between bottom-border padding-bottom-10">
            <div class="w40">
              <div class="wrapper align-hor center-hor">
                <div class="comment animate bg-light-grey margin-bottom-5 w30 margin-right-5"></div>
                <div class="comment animate bg-light-grey margin-bottom-5 w70"></div>
              </div>
            </div>
            <div class="w30">
              <div class="wrapper align-hor end-ver">
                <div class="comment animate bg-light-grey margin-bottom-5 w50"></div>
                <div class="wrapper align-ver center-hor end-ver">
                  <div class="comment animate bg-light-grey w85"></div>
                  <div class="comment animate bg-light-grey w85"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="padding-horizontal-20">
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-5 w30 margin-right-5"></div>
            </div>
            <div class="wrapper">
              <div class="comment animate bg-light-grey margin-bottom-10 w70"></div>
              <div class="comment animate bg-light-grey margin-bottom-10 w85"></div>
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey margin-bottom-10 w50"></div>
              <div class="comment animate bg-light-grey margin-bottom-10 w70"></div>
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey margin-bottom-10 w50"></div>
            </div>
          </div>
          <div class="wrapper align-hor space-between">
            <div class="comment animate bg-light-grey w50 margin-right-5"></div>
            <div class="comment animate bg-light-grey w10"></div>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer" style="display: flex;
    flex-direction: row; justify-content: center;
    height: 30px; border-top: 1px solid #EFEFEF;">
      <div class="padding-vertical-5"
           :style="{background: bgTheme}"
           style="margin-right: auto;
                  margin-left: auto;
                  width: 90%;
                  align-items: center;
                  display:flex;
                   border-radius: 4px;
                  justify-content: center;"
           @click="toggleGiftModal(true, giftCardData)">
        <!--        <router-link :to="{name: 'quiz_questions', params: {id: game_data.id}}">
                  <a class="btn text-uppercase" style="color: #fff; padding: 8px 0; background: var(&#45;&#45;bg-color); width: 150px; height: 20px; border-radius: 50px;" role="button">Play Quiz Now</a>
                </router-link>-->
        <span
           class="btn text-uppercase"
           style="color: #fff; padding: 8px 0;
            width: 150px; height: 20px; border-radius: 50px;"
           role="button">REDEEM</span>
      </div>

    </footer>
  </div>

</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  import OverlapHeader from '@/components/overlapped-header'
  import Milestone from '@/components/milestone'
  import GiftCardPopup from '@/components/gift-card-popup'
  export default {
    mixins: [globals],
    components: {
      'header-o': OverlapHeader,
      'milestone': Milestone,
      'gift-popup': GiftCardPopup
    },
    data() {
      return {
        headerData: {
          onlyHeader: true,
          balance: true
        },
        giftCardData: {},
        showTNC: false,
      }
    },
    computed: {
      isShowTNC: function() {
        return this.showTNC;
      }
    },
    methods: {
      toggleTNC(state) {
        this.showTNC = state;
      },
      getGiftCardDetails(id) {
        var url = this.$store.getters.flyyDomain+'/get_gift_card/'+id;
        var headers = this.$store.getters.headers;
        axios.get(url, {
          mode: 'no-cors',
          headers: headers
        }).then((resp) => {
          if(resp.data.success) {
            var gift_card = resp.data.gift_card;
            this.giftCardData = gift_card;
          }
        });
      }
    },
    created() {
      this.$store.state.showHeader = false;
      this.$store.state.headTitle = "Card Details";
      if(!this.isEmpty(this.$route.params)) {
        this.getGiftCardDetails(this.$route.params.id);
        this.$store.state.user.headerBalance.show = true;
      }
    }
  }
</script>
<style>
  .card-details {
    min-height: 250px;
    max-height: 300px;
    margin: auto 10px;
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 18px 18px;
    text-align: center;
    background-color: #fff;
    z-index: 99;

  }
</style>



// WEBPACK FOOTER //
// src/screens/gift-card-detail.vue